export default "__VITE_ASSET__BQTF4fmb__"